import React, { useEffect, useState } from 'react'

import { Theme, Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'

import SelectImageVideo from './AddOns/SelectImageVideo'
import SelectTemplate from './AddOns/SelectTemplate'
import { PostingScreen } from '../../types/types'
import { GeneralPostingOptions, PostingTemplate } from '@professocial/professocialTypes/types/commonTypes'
import SelectTags from './AddOns/SelectTags'
import { useSelector } from 'react-redux'
import { getGeneralPostingOptions } from '../../../store/common/common.selectors'

const useStyles = makeStyles((theme: Theme) => ({
  root: {

  },
}))

interface IProps {
  posting: PostingTemplate
  changePosting?: (post: PostingTemplate) => void
  changePostingScreen?: (screen: PostingScreen) => void
}

const CreatePostingAddOns: React.FC<IProps> = (props) => {
  const classes = useStyles()
  const generalPostingOptions: GeneralPostingOptions = useSelector(getGeneralPostingOptions)
  const [posting, setPosting] = useState<PostingTemplate>(props.posting)

  useEffect(() => {
    setPosting(props.posting)
  }, [props.posting],
  )

  return (
    <>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          {(generalPostingOptions.allowImageUpload || generalPostingOptions.allowVideoUpload) &&
            <SelectImageVideo
              posting={posting}
              changePosting={(post: PostingTemplate) => { props.changePosting && props.changePosting(post) }}
              changePostingScreen={(screen: PostingScreen) => { props.changePostingScreen && props.changePostingScreen(screen) }}
            />}
          <>
            {/* <SelectEmotion */}
            {/*  posting={posting} */}
            {/*  changePosting={(post: PostingTemplate) => { props.changePosting && props.changePosting(post) }} */}
            {/*  changePostingScreen={(screen: PostingScreen) => { props.changePostingScreen && props.changePostingScreen(screen) }} */}
            {/* /> */}
            {/* <SelectLocation */}
            {/*  posting={posting} */}
            {/*  changePosting={(post: PostingTemplate) => { props.changePosting && props.changePosting(post) }} */}
            {/*  changePostingScreen={(screen: PostingScreen) => { props.changePostingScreen && props.changePostingScreen(screen) }} */}
            {/* /> */}
          </>
          {generalPostingOptions.allowTags &&
            <SelectTags
              posting={posting}
              changePosting={(post: PostingTemplate) => { props.changePosting && props.changePosting(post) }}
              changePostingScreen={(screen: PostingScreen) => { props.changePostingScreen && props.changePostingScreen(screen) }}
            />}
          {generalPostingOptions.templateSelection &&
            <SelectTemplate
              posting={posting}
              changePosting={(post: PostingTemplate) => { props.changePosting && props.changePosting(post) }}
              changePostingScreen={(screen: PostingScreen) => { props.changePostingScreen && props.changePostingScreen(screen) }}
            />}
        </Grid>
      </Grid>
    </>
  )
}

export default CreatePostingAddOns
